import React, { Component } from 'react'
import http from 'src/helper/http'
import './index.less'
import langM from './lang'
import {
  setDocumentTitle,
  setUidToken,
  showConsole,
  getlang,
  setlang,
  score,
  unix2date6,
  forbidScroll,
  jumpToUser,
  jumpToRoom,
  debounce,
  throttle,
  inject,
  observer,
  openViewTransparent,
  closeWebViewPage,
  closeWebview
} from '../../../helper/devTools.js'

import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'


@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    // this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('APP GAME')
  }
  state = {
    messageTxt: "",
    currentNum: 500,
    enoughTip: false,
    exchangeTip: false,
    popUpShow: false,
    uid: 0,
    accesstoken: '',
    typeStatus: 1,
    rankList: [],
    recordList: [],
    myRank: {},
    scrollParams: "0,30",
    hasMore: false,
    lang:langM.en,
    language:'en',
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async getMoreList() {
    let recordL = await this.getRecordList(this.state.scrollParams)
    let list = this.state.recordList
    recordList && recordList.res && recordList.res.list.map((i) => {
      list.push(i)
    })
    this.setState({
      recordL: list,
      hasMore: recordL && recordL.res && recordL.res.hasMore,
      scrollParams: recordL && recordL.res && recordL.res.scroll,
    })
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)

    let rankL = await this.getRankList()
    let recordL = await this.getRecordList(this.state.scrollParams)
    console.log(rankL)
    console.log(recordL)
    this.setState({
      rankList: rankL,
      recordList: recordL && recordL.res && recordL.res.list,
      scrollParams: recordL && recordL.res && recordL.res.scroll,
    })

  }

  handleMessage(event) {
    // MDN 建议在处理消息前要先检查发送方的域名，防止恶意消息
    if (event.origin === 'http://192.168.0.40:8000/#/app/appgames') {
      // 处理消息
      console.log(event, 'event')
      // 发送回执给发送方
      event.source.postMessage('Message received', event.origin);
    }
  }

  async componentWillMount (){
    window.addEventListener(
      'message',
       async(e)=> {
        if (e.data && e.data != '') {
          try {
            let d = JSON.parse(e.data)
            if (d.msgtp == 'popRecharge') {
              return   
            }
            if (d.msgtp == 'popClose') return closeWebview()
          } catch (error) {
            console.error(error)
          }
        }
      },
      false
    )
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {

    const { uid:lguid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid||lguid,
      accesstoken: accesstoken,
    })

  }

  async getRankList() {
    let result = await http.post('/web/slot/ruby/rank')
    this.setState({
      myRank: result && result.res && result.res.myrank
    })
    return result && result.res && result.res.list
  }
  async getRecordList(v) {
    let result = await http.post('/web/slot/ruby/record', { scroll: v })
    return result
  }

  changeNum(num) {
    this.setState({
      currentNum: num
    })
  }
  goExchange(type) {
    if (type == 1) {
      this.setState({
        enoughTip: false
      })
    }
    if (type == 2) {
      this.setState({
        enoughTip: false,
        exchangeTip: true
      })
    }
  }

  render() {
    // 热游摩天轮
    let GameURL = 'https://cdn-web.hotgame.win/game/GreedyStar/seven/?sdk=chatie&gameID=1153877559'

    //测试环境
    if (config.host == "https://api-test.thechatie.com") {
      GameURL = 'https://cdn-web.hotgame.win/game/GreedyStar/seven/?sdk=chatie&gameID=1153877559&game_env=dev'
    }
    let { tk } = this.props.location.query
    return (
      <div className={`game1`}>

          <iframe
            className="app-games-iframe"
            id='app-games-iframe-main'
            src={`${GameURL}&uid=${this.state.uid}&accesstoken=${tk}&lang=${this.state.language == "zh" ? "en" : this.state.language}`}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
          </iframe>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-1/index.js